<template>
  <div class="user" @click="adminshow">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <!-- 标题 -->
        <span style="font-size: 24px">人员管理</span>
        <div class="head-text">
          <!-- 新建事件 -->
          <el-input
            placeholder="请输入用户姓名"
            class="search-input"
            v-model="query"
          ></el-input>
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="getData"
            class="mar-r80"
          ></el-button>
          <el-button type="primary" @click="batchAddFile = true"
            >导入Excel</el-button
          >
          <el-button type="primary" @click="positionManagement"
            >职位管理</el-button
          >
          <el-button type="primary" @click="addDialogFormVisible1Open"
            >新建</el-button
          >
          <el-button type="primary" @click="invDialogFormVisible2"
            >邀请</el-button
          >
          <el-button type="primary" @click="exportExcel">导出</el-button>
        </div>
      </div>
      <el-container>
        <!-- 这里是侧边栏-->
        <div class="mar-top20">
          <el-aside width="200px" class="elAside">
            <el-button size="small" type="primary" @click="showAll"
            >显示全部人员</el-button
          >
            <div class="zTreeDiv">
              <ul id="buildTree" class="ztree"></ul>
            </div>
            <div id="buildRmenu">
              <ul>
                <li id="addBuild">添加</li>
                <li id="updateBuild">修改</li>
                <li id="delBuild">删除</li>
              </ul>
            </div>
          </el-aside>
        </div>
        <el-main>
          <div class="rygl-table">
            <el-table
              align="center"
              class="margin-20 table width100"
              v-loading="loading"
              :data="userList"
              height="72vh"
              @selection-change="handleSelectionChange"
            >
              <el-table-column
                align="center"
                type="selection"
                width="55"
              ></el-table-column>
              <el-table-column
                type="index"
                align="center"
                class="ss"
                label="序号"
                width="80"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="Account"
                label="账号"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="Name"
                label="姓名"
              ></el-table-column>
              <el-table-column align="center" label="所属组织" width="130px">
                <template slot-scope="scope">
                  <el-cascader
                    @change="(val) => xz([val, scope.row])"
                    :options="qyList"
                    :props="{
                      checkStrictly: true,
                      value: 'ID',
                      label: 'label',
                      children: 'children',
                    }"
                    clearable
                    :placeholder="scope.row.CompanyDeptName"
                  ></el-cascader>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="ProfessionalTitle"
                label="职位"
                width="140px"
              >
                <template slot-scope="scope">
                  <el-select
                    filterable
                    v-model="scope.row.ProfessionalTitle"
                    placeholder="请选择"
                  >
                    <el-option
                      @click.native.prevent="inputText(scope.row, item.cptt03)"
                      v-for="item in positionManagementList"
                      :key="item.cptt03"
                      :label="item.cptt03"
                      :value="item.cptt03"
                    ></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="PhoneNumber"
                label="手机号"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="Email"
                label="邮箱"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="Address"
                label="地点"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="AddTime"
                label="创建日期"
              ></el-table-column>
              <el-table-column align="center" label="启用禁用">
                <template slot-scope="scope">
                  <el-switch
                    :disabled="scope.row.isEnterprise == 0 ? true : false"
                    v-model="scope.row.State == 1 ? false : true"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    @change="stopDialogFormVisible(scope.row)"
                  ></el-switch>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="time"
                label="到期时间"
              ></el-table-column>
              <el-table-column align="center" label="操作" width="250">
                <template slot-scope="scope">
                  <el-button
                    size="small"
                    type="primary"
                    plain
                    @click="seeDialogFormVisible(scope.row)"
                    >查看</el-button
                  >
                  <el-button
                    v-if="scope.row.isEnterprise != 0"
                    size="small"
                    type="danger"
                    plain
                    @click="delCompanyUser(scope.row)"
                    >移除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>

            <el-pagination
              align="center"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="pagenum"
              :page-sizes="[10, 50, 100]"
              :page-size="pagesize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
              class="mar-top20"
            ></el-pagination>
          </div>
        </el-main>
      </el-container>

      <!-- 新建 -->
      <el-dialog
        :close-on-click-modal="false"
        title="新建账户信息"
        :visible.sync="addDialogFormVisible1"
        top="2%"
      >
        <el-form
          :model="addList"
          label-width="80px"
          ref="editUserForm"
          :rules="rules2"
        >
          <el-form-item label="姓名" prop="user04">
            <el-input
              v-model="addList.user04"
              auto-complete="off"
              placeholder="请输入姓名"
            ></el-input>
          </el-form-item>
          <el-form-item label="账号" prop="user02">
            <el-input
              v-model="addList.user02"
              auto-complete="off"
              placeholder="请输入账号"
            ></el-input>
          </el-form-item>
          <el-form-item label="手机号" prop="user11">
            <el-input
              v-model="addList.user11"
              auto-complete="off"
              placeholder="请输入手机号"
            ></el-input>
          </el-form-item>
          <el-form-item label="登录密码" prop="user03">
            <el-input
              show-password
              v-model="addList.user03"
              type="password"
              placeholder="请输入登录密码"
              auto-complete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="重复密码" prop="YzPassword">
            <el-input
              show-password
              v-model="YzPassword"
              type="password"
              auto-complete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="所属组织" prop="deptIds">
            <el-cascader
              v-model="addList.deptIds"
              placeholder="请选择组织"
              :options="qyList"
              :props="{
                checkStrictly: true,
                value: 'ID',
                label: 'label',
                children: 'children',
              }"
              clearable
            ></el-cascader>
          </el-form-item>
          <el-form-item label="职位" prop="positions">
            <el-select v-model="addList.positions" placeholder="请选择职位">
              <el-option
                v-for="(item, index) in positionManagementList"
                :key="index.cptt03"
                :label="item.cptt03"
                :value="item.cptt03"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="性别" prop="user05">
            <el-select
              filterable
              v-model="addList.user05"
              placeholder="请选择性别"
            >
              <el-option label="男" value="男"></el-option>
              <el-option label="女" value="女"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="出生年月" prop="user06">
            <template>
              <el-date-picker
                v-model="addList.user06"
                type="date"
                placeholder="选择日期"
              ></el-date-picker>
            </template>
          </el-form-item>
          <el-form-item label="职称" prop="user07">
            <el-select v-model="addList.user07" placeholder="请选择职称">
              <el-option
                v-for="(item, index) in jobs"
                :key="index"
                :label="item.name"
                :value="item.name"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="学历" prop="user08">
            <el-select v-model="addList.user08" placeholder="请选择学历">
              <el-option
                v-for="(item, index) in education"
                :key="index"
                :label="item.name"
                :value="item.name"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="毕业院校">
            <el-input
              v-model="addList.user09"
              auto-complete="off"
              placeholder="请输入毕业院校"
            ></el-input>
          </el-form-item>
          <el-form-item label="联系地址" prop="user10">
            <div class="container">
              <div class="dome-main">
                <div
                  class="city-picker-selector"
                  id="city-picker-selector1"
                ></div>
              </div>
            </div>
            <el-input v-model="detialAdree" type="textarea"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="addDialogFormVisible1 = false">取 消</el-button>
          <el-button type="primary" @click="editUserSubmit('editUserForm')"
            >确 定</el-button
          >
        </div>
      </el-dialog>
      <!-- 查看 -->
      <el-dialog
        :close-on-click-modal="false"
        title="查看用户详情"
        :visible.sync="seeDialogFormVisible1"
        width="80%"
      >
        <el-row>
          <el-col :span="11" :offset="1">
            <el-form :model="addForm" label-width="80px">
              <el-form-item label="用户名" prop="user02">
                <el-input
                  :disabled="true"
                  v-model="addForm.user02"
                  auto-complete="off"
                ></el-input>
              </el-form-item>
              <el-form-item label="姓名" prop="user04">
                <el-input
                  :disabled="true"
                  v-model="addForm.user04"
                  auto-complete="off"
                ></el-input>
              </el-form-item>
              <el-form-item label="性别" prop="user05">
                <el-select
                  filterable
                  :disabled="true"
                  v-model="addForm.user05"
                  placeholder="请选择您的性别"
                >
                  <el-option label="男" value="男"></el-option>
                  <el-option label="女" value="女"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="出生年月" prop="user06">
                <el-input
                  :disabled="true"
                  v-model="addForm.user06"
                  auto-complete="off"
                ></el-input>
              </el-form-item>
              <el-form-item label="职称" prop="user07">
                <el-input
                  :disabled="true"
                  v-model="addForm.user07"
                  auto-complete="off"
                ></el-input>
              </el-form-item>
              <el-form-item label="学历" prop="user08">
                <el-input
                  :disabled="true"
                  v-model="addForm.user08"
                  auto-complete="off"
                ></el-input>
              </el-form-item>
              <el-form-item label="毕业院校" prop="user09">
                <el-input
                  :disabled="true"
                  v-model="addForm.user09"
                  auto-complete="off"
                ></el-input>
              </el-form-item>
              <el-form-item label="联系地址" prop="user10">
                <el-input
                  :disabled="true"
                  v-model="addForm.user10"
                  auto-complete="off"
                ></el-input>
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="11" :offset="1">
            <div class="user-loading">
              <img src="../../assets/img/dw.png" alt />
              <p>
                机构组织：
                <span>{{ obligation.dept }}</span>
              </p>
            </div>
            <div class="user-loading">
              <img src="../../assets/img/zw.png" alt />
              <p>
                担任职位：
                <span>{{ obligation.zhiwei }}</span>
              </p>
            </div>
            <div class="user-loading">
              <el-button size="small" @click="jopProject(1)"
                >管理的项目</el-button
              >
              <el-button size="small" @click="jopProject(0)" class="mar-left10"
                >参与的项目</el-button
              >
            </div>
            <el-table
              class="margin-20 table width100"
              v-loading="loading"
              :data="userList2"
              border
              max-height="400"
              @selection-change="handleSelectionChange"
            >
              <el-table-column
                align="center"
                type="selection"
                width="55"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="proj02"
                label="项目编号"
                width="80"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="proj07"
                label="项目简称"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="rolename"
                label="岗位"
              ></el-table-column>
            </el-table>
            <!-- <div class="page"> -->
            <el-pagination
              align="center"
              @size-change="handleSizeChange2"
              @current-change="handleCurrentChange2"
              :current-page="pageIndex2"
              :page-sizes="[10, 50, 100]"
              :page-size="pageSize2"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total2"
            ></el-pagination>
            <!-- </div> -->
          </el-col>
        </el-row>
        <div slot="footer" class="dialog-footer"></div>
      </el-dialog>
      <!-- 邀请 -->
      <el-dialog
        :close-on-click-modal="false"
        title="输入邀请账户信息"
        :visible.sync="invDialogFormVisible1"
      >
        <el-row>
          <!-- <el-col :span="3" :offset="2" class="yq-col">
          <img src="../../assets/img/bmmc.png" alt />
          <span>账号</span>
        </el-col>
        <el-col :span="3" class="yq-col">
          <img src="../../assets/img/dh.png" alt />
          <span>手机号</span>
        </el-col>-->
          <el-col :span="8" class="yq-col">
            <img src="../../assets/img/sszz.png" alt />
            <span>账号/手机号/邮箱</span>
          </el-col>
          <el-col :span="8" class="yq-col">
            <img src="../../assets/img/zw.png" alt />
            <span>部门</span>
          </el-col>
          <el-col :span="6" class="yq-col">
            <img src="../../assets/img/zw.png" alt />
            <span>职位</span>
          </el-col>
        </el-row>
        <el-row v-for="(item, index) in inviteList" :key="item.id">
          <!-- <el-col :span="3" :offset="2">
          <el-input v-model="inviteList[index].Account"></el-input>
        </el-col>
        <el-col :span="3">
          <el-input v-model="inviteList[index].Phone"></el-input>
        </el-col>-->
          <el-col :span="8">
            <el-input
              v-model="inviteList[index].Email"
              class="width80"
            ></el-input>
          </el-col>
          <el-col :span="8">
            <el-cascader
              @change="(val) => changeDept(val, item, index)"
              :options="qyList"
              :props="{
                checkStrictly: true,
                value: 'ID',
                label: 'label',
                children: 'children',
              }"
              clearable
            ></el-cascader>
          </el-col>
          <el-col :span="6">
            <el-select
              filterable
              v-model="inviteList[index].zhiwei"
              placeholder="请选择"
            >
              <el-option
                v-for="item in positionManagementList"
                :key="item.cptt03"
                :label="item.cptt03"
                :value="item.cptt03"
              ></el-option>
            </el-select>
            <!-- 1111 -->
          </el-col>
          <el-col :span="2">
            <el-button
              @click="addInviteList(inviteList.length)"
              v-if="index == 0"
              >+</el-button
            >
            <el-button @click="delInviteList(index)" v-if="index > 0"
              >-</el-button
            >
          </el-col>
        </el-row>
        <el-row class="mar-top20">
          <el-col :span="2" :offset="10">
            <el-button type="primary" @click="invite">邀请</el-button>
          </el-col>
          <el-col :span="4">
            <el-button type="danger" @click="invDialogFormVisible1 = false"
              >取消</el-button
            >
          </el-col>
        </el-row>
      </el-dialog>
      <!-- 职位管理 -->
      <el-dialog
        :close-on-click-modal="false"
        title="职位管理"
        :visible.sync="positionManagementShow"
        top="2%"
        width="30%"
      >
        <el-row class="padding0">
          <el-col :span="5" :offset="19">
            <el-button size="small" type="primary" @click="AddCompanyTitle"
              >新增职位</el-button
            >
          </el-col>
        </el-row>
        <el-table
          align="center"
          class="table width100"
          v-loading="loading"
          :data="positionManagementList"
          height="72vh"
        >
          <el-table-column
            align="center"
            prop="cptt03"
            label="职位名称"
          ></el-table-column>
          <el-table-column align="center" label="操作" width="250">
            <template slot-scope="scope">
              <el-button
                @click="UpdateCompanyTitle(scope.row)"
                size="small"
                type="primary"
                plain
                >重命名</el-button
              >
              <el-button
                v-if="scope.row.isEnterprise != 0"
                size="small"
                type="danger"
                plain
                @click="DelCompnayTitel(scope.row)"
                >移除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>
    </el-card>
    <!-- 选择截止时间 -->
    <el-dialog
      :close-on-click-modal="false"
      title="选择到期日期"
      :visible.sync="changeEndTime"
      top="2%"
      width="30%"
    >
      <el-row>
        <el-col :span="18">
          <el-date-picker
            v-model="stateEndTime"
            type="date"
            :picker-options="pickerOptions"
            placeholder="不选则为永久有效"
          >
          </el-date-picker>
        </el-col>
        <el-col :span="4">
          <el-button type="primary" @click="stopUser">确定</el-button>
        </el-col>
      </el-row>
    </el-dialog>
    <!-- 批量文件添加节点 -->
    <el-dialog
      :close-on-click-modal="false"
      title="xlsx导入"
      :visible.sync="batchAddFile"
      width="40%"
      center
      v-loading="Uploadloading"
    >
      <p>
        点击下载模板文件：
        <a style="color: red;cursor: pointer;" @click="ExportPersonTemplate"
          >示例表格.XLSX</a
        >并按要求填好后上传
      </p>
      <el-upload
        ref="upload"
        class="upload-demo"
        :action="actionUrl"
        :on-change="handleChange"
        :file-list="fileList"
        :limit="1"
        :data="uploadData"
        :before-upload="beforeUpload"
        accept=".xlsx"
        :auto-upload="false"
        :on-success="uploadSuccess"
        :headers="importHeaders"
        :on-exceed="handleExceed"
      >
        <el-button slot="trigger" size="small" type="primary"
          >选择文件</el-button
        >
        <el-button
          style="margin-left: 10px"
          size="small"
          type="success"
          @click="submitUpload"
          >上传到服务器</el-button
        >
        <div slot="tip" class="el-upload__tip">只能上传xlsx文件</div>
      </el-upload>
    </el-dialog>
  </div>
</template>
<script>
// excel导出
import FileSaver from "file-saver";
import XLSX from "xlsx";
import {
  AddCorporateGovernanceRen,
  SwitchsCorporateGovernance,
  GetCorporateGovernanceDepartment,
  UpdateCorporateGovernanceDepartment,
  UpdateCorporateGovernancePosition,
  InviteCorporateGovernanceUser,
  RemoveCorporateGovernanceUser,
  GetUserInfo,
  GetProjectList,
  AddCompanyUser,
  QuitUser,
  delCompanyUser,
  AddCompanyDept,
  DelCompanyDept,
  EditCompanyDept,
  GetProjectDept,
  GetCompanyTitel,
  AddCompanyTitle,
  DelCompnayTitel,
  ChangeCompanyDeptOrder,
  UpdateCompanyTitle,
  ExportPersonTemplate,
} from "@/setAxios.js";
export default {
  name: "notice",
  data() {
    // 邮箱格式验证
    var checkAge = (rule, value, callback) => {
      var reg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
      if (this.addList.user12.search(reg) == -1) {
        return callback(new Error("请输入正确的邮箱"));
      } else {
        callback();
      }
    };
    // 手机格式验证
    var checkAge1 = (rule, value, callback) => {
      var reg = /^1[3-9]\d{9}$/;
      if (this.addList.user11.search(reg) == -1) {
        return callback(new Error("请输入正确的手机"));
      } else {
        callback();
      }
    };
    // 重复密码一致验证
    var validatePass = (rule, value, callback) => {
      if (value == null) {
        callback(new Error("请输入密码"));
      } else if (value.length < 6) {
        callback(new Error("密码至少6位"));
      } else {
        if (this.addList.user03 != "") {
          this.$refs.editUserForm.validateField("checkPass");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (this.addList.user03 != this.YzPassword) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };

    return {
      actionUrl: this.$store.state.baseUrl + "/api/ImportUserExcel",
      importHeaders: { token: localStorage.getItem("token") },
      uploadData: {
        companyId: localStorage.pid,
      },
      Uploadloading: false,
      fileList: [],
      batchAddFile: false,
      pickerOptions: {
        shortcuts: [
          {
            text: "一周",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            },
          },
          {
            text: "一月",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 30);
              picker.$emit("pick", date);
            },
          },
          {
            text: "三个月",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 90);
              picker.$emit("pick", date);
            },
          },
          {
            text: "半年",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 182);
              picker.$emit("pick", date);
            },
          },
          {
            text: "一年",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 365);
              picker.$emit("pick", date);
            },
          },
          {
            text: "到年底",
            onClick(picker) {
              const date = new Date();
              var year = date.getFullYear();
              var date2 = new Date(year, 11, 30, 23, 59, 59, 999);
              date.setTime(date2);
              picker.$emit("pick", date);
            },
          },
        ],
      },
      changeEndTime: false,
      // 启用禁用时的单行数据
      stateRow: null,
      stateEndTime: null,
      // 重复密码验证
      YzPassword: null,
      zNodes: null,
      selectNode: null,
      zTeeObj: null,
      id: "",
      ids: "",
      positionManagementShow: false,
      positionManagementList: [],
      education: [
        { name: "小学" },
        { name: "初中" },
        { name: "中专/高中" },
        { name: "专科" },
        { name: "本科" },
        { name: "硕士研究生" },
        { name: "博士研究生" },
      ],
      jobs: [
        { name: "初级" },
        { name: "中级" },
        { name: "副高级" },
        { name: "高级" },
      ],
      detialAdree: "",
      inputShow: false,
      value2: false,
      loading: false,
      value1: "",
      obligation: {},
      userList: [],
      userList2: [],
      inviteList: [
        {
          CompanyId: localStorage.getItem("pid"),
        },
      ],
      qyList: [],
      addList: {},
      query: "",
      total: 0,
      total2: 0,
      pagesize: 10,
      pageSize2: 10,
      pagenum: 1,
      pageIndex2: 1,
      btnShow: true,
      seeDialogFormVisible1: false,
      addDialogFormVisible1: false,
      invDialogFormVisible1: false,
      multipleSelection: [],
      editForm: {},
      addForm: {},
      rules2: {
        user02: [
          { required: true, message: "请输入用户账号", trigger: "blur" },
        ],
        user03: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { validator: validatePass, trigger: "blur" },
        ],
        YzPassword: [
          { required: true, validator: validatePass2, trigger: "blur" },
        ],
        user04: [
          { required: true, message: "请输入用户姓名", trigger: "blur" },
        ],
        deptIds: [{ required: true, message: "请选择组织", trigger: "change" }],
        positions: [
          { required: true, message: "请输入用户职位", trigger: "change" },
        ],
        user11: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { validator: checkAge1, trigger: "blur" },
        ],
        user05: [{ required: true, message: "请选择性别", trigger: "blur" }],
      },
      deptList: {},
      deptList2: {},
      position: ["普通用户", "部门经理", "公司高层", "超管"],
      // positionList: [],
      deptIds: "",
      // deptIDList: [],
    };
  },
  //   模型初始化时调用方法请求接口
  mounted() {
    this.GetCorporateGovernanceDepartment();
  },
  created() {
    this.GetCompanyTitel();
  },
  methods: {
    //企业导出人员模板
    async ExportPersonTemplate() {
      let res = await ExportPersonTemplate({ cid: this.$store.state.pid });
      if (res.Code == 0) {
        this.$message.error(res.Message);
      } else {
        var a = document.createElement("a");
        a.setAttribute("href", this.$store.state.baseUrl + res.Data);
        a.setAttribute("target", "_blank");
        a.setAttribute("id", "js_a");
        a.setAttribute("download", "download");
        //防止反复添加
        if (document.getElementById("js_a")) {
          document.body.removeChild(document.getElementById("js_a"));
        }
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(document.getElementById("js_a"));
      }
    },
    submitUpload() {
      if (this.fileList.length > 0) {
        this.$refs.upload.submit();
      } else {
        this.$message({
          type: "warning",
          message: "请选择文件后上传",
        });
      }
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    beforeUpload(file) {
      var index = file.name.lastIndexOf(".");
      var suffix = file.name.substring(index + 1);
      const extension = suffix === "xlsx";
      //(suffix);
      if (!extension) {
        this.$message({
          message: "上传文件只能是 xlsx格式!",
          type: "warning",
        });
        this.Uploadloading = true;
      }
      return extension;
    },
    handleChange(file, fileList) {
      this.fileList = fileList.slice(-3);
    },
    // 上传成功
    uploadSuccess(data) {
      this.Uploadloading = false;
      this.batchAddFile = false;
      if (data.Code > 0) {
        this.$message({
          type: "success",
          message: data.Message,
        });
        this.getData();
      } else {
        this.$message({
          type: "warning",
          message: data.Message,
        });
      }
    },
    //更新职位
    UpdateCompanyTitle(data) {
      this.$prompt("请输入职位名称", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then(({ value }) => {
        data.cptt03 = value;
        UpdateCompanyTitle(data).then((res) => {
          if (res.Code > 0) {
            this.$message({
              type: "success",
              message: "更新职位成功",
            });
          }
          this.getData();
        });
      });
    },
    stopUser() {
      let params = {
        uid: this.stateRow.id,
        qid: localStorage.pid,
        state: this.stateRow.State == 0 ? 1 : 0,
        Time: this.stateEndTime,
      };
      SwitchsCorporateGovernance(params).then((res) => {
        if (res.Code === 1) {
          this.$message({
            type: "success",
            message: "修改成功",
          });
        }
        this.changeEndTime = false;
        this.getData();
      });
    },
    // 职位管理
    async positionManagement() {
      this.positionManagementShow = true;
    },
    async GetCompanyTitel() {
      let params = {
        cid: localStorage.getItem("pid"),
      };
      let res = await GetCompanyTitel({ params });
      this.positionManagementList = res.Data;
    },
    AddCompanyTitle() {
      this.$prompt("请输入职位名称", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then(({ value }) => {
        let params = {
          cptt02: localStorage.pid,
          cptt03: value,
        };
        AddCompanyTitle(params).then((res) => {
          if (res.Code > 0) {
            this.$message({
              type: "success",
              message: "新增职位成功",
            });
            this.GetCompanyTitel();
          }
        });
      });
    },
    async DelCompnayTitel(data) {
      let params = {
        id: data.cptt01,
      };
      let res = await DelCompnayTitel(params);
      if (res.Code > 0) {
        this.$message({
          type: "success",
          message: "删除成功",
        });
        this.GetCompanyTitel();
      }
    },
    jopProject(value) {
      let params2 = {
        pid: localStorage.pid,
        uid: this.id,
        pageIndex: this.pageIndex2,
        pageSize: this.pageSize2,
        isPM: value == undefined ? "" : value,
      };
      GetProjectList({ params: params2 }).then((res) => {
        this.project = res.Data;
        this.userList2 = res.Data.list;
        this.total2 = res.Data.total;
      });
    },
    changeDept(val, item, index) {
      this.inviteList[index].DeptId = val[val.length - 1];
    },
    showAll() {
      this.ids = "null";
      this.getData();
    },
    // 初始化Ztree
    init() {
      var _this = this;

      var selectNode;
      var setting = {
        view: {
          selectedMulti: false,
        },
        check: {
          enable: true,
        },
        data: {
          key: {
            name: "dept02",
          },
          simpleData: {
            enable: true,
            idKey: "dept01",
            pIdKey: "dept05",
          },
        },
        edit: {
          enable: true,
          showRemoveBtn: false,
          showRenameBtn: false,
          drag: {
            isMove: true,
            inner: true,
            prev: false,
            next: true,
          },
        },
        callback: {
          onRightClick: OnRightClick,
          beforeRename: beforeRename,
          onCheck: onCheck,
          onClick: onclick,
          beforeDrop: beforeDrop,
        },
      };
      this.zTeeObj = $.fn.zTree.init($("#buildTree"), setting, this.zNodes);
      this.zTeeObj.checkAllNodes(true);
      var checkedNodes = this.zTeeObj.getCheckedNodes();
      _this.ids = "";
      var _split = "";
      checkedNodes.forEach((element) => {
        _this.ids += _split + element.dept01;
        _split = ",";
      });
      _this.getData();
      // 选中状态
      function onCheck() {
        var checkedNodes = _this.zTeeObj.getCheckedNodes();
        _this.ids = "";
        var _split = "";
        checkedNodes.forEach((element) => {
          _this.ids += _split + element.dept01;
          _split = ",";
        });
        _this.getData();
      }
      //点击事件
      function onclick(event, treeId, treeNode) {
        _this.pagenum = 1;
        _this.ids = treeNode.dept01;
        _this.getData();
      }

      // 拖拽功能
      function beforeDrop(treeId, treeNodes, targetNode, moveType) {
        var moveNode = treeNodes[0];
        switch (moveType) {
          case "prev":
          case "next":
          case "inner":
            ChangeCompanyDeptOrder({
              oid: moveNode.dept01,
              nid: targetNode.dept01,
              moveType: moveType,
            });
            _this.$message({
              type: "success",
              message: "移动成功",
            });
            return true;
            break;
        }
        return false;
      }
      // 在ztree上的右击事件
      function OnRightClick(event, treeId, treeNode) {
        _this.selectNode = treeNode;
        if (treeNode == null) {
          showRMenu("root", event.clientX, event.clientY);
        } else {
          showRMenu("node", event.clientX, event.clientY);
        }
      }
      //鼠标按下事件
      function onBodyMouseDown(event) {
        if (
          !(
            event.target.id == "buildRmenu" ||
            $(event.target).parents("#buildRmenu").length > 0
          )
        ) {
          $("#buildRmenu").css({ visibility: "hidden" });
        }
      }
      //显示右键菜单
      function showRMenu(type, x, y) {
        if (type == "root") {
          $("#addBuild").show();
          $("#updateBuild").hide();
          $("#delBuild").hide();
        } else {
          $("#addBuild").show();
          $("#updateBuild").show();
          $("#delBuild").show();
        }
        $("#buildRmenu").show();
        $("#buildRmenu").css({
          top: y + "px",
          left: x + "px",
          visibility: "visible",
        }); //设置右键菜单的位置、可见
        $("body").bind("mousedown", onBodyMouseDown);
      }

      $("#buildRmenu ul li")
        .unbind()
        .bind("click", function () {
          $("#buildRmenu").css({
            visibility: "hidden",
          });
          var type = $(this).attr("id");
          if (type == "addBuild") {
            var newNode = {},
              params = {};
            var node = _this.selectNode;
            if (_this.selectNode == null) {
              params = {
                dept01: 0,
                dept02: "新建配置",
                dept03: localStorage.getItem("pid"),
                dept04: new Date(),
                dept05: 0,
              };
            } else {
              params = {
                dept01: 0,
                dept02: "新建配置",
                dept03: localStorage.getItem("pid"),
                dept04: new Date(),
                dept05: _this.selectNode.dept01,
              };
            }
            AddCompanyDept({ model: params }).then((res) => {
              if (res.Code > 0) {
                newNode = res.Data;
                _this.zTeeObj.addNodes(_this.selectNode, newNode);
                var currentNode = _this.zTeeObj.getNodeByParam(
                  "dept01",
                  newNode.dept01
                );
                _this.zTeeObj.selectNode(currentNode);
                _this.zTeeObj.editName(currentNode);
              } else {
                _this.$message({
                  type: "waring",
                  message: "添加失败",
                });
              }
            });
          } else if (type == "delBuild") {
            _this.$confirm("确认删除当前以及附属节点？").then((_) => {
              let params = { ids: _this.selectNode.dept01 };
              DelCompanyDept(params).then((res) => {
                if (res.Code > 0) {
                  _this.$message({
                    type: "success",
                    message: "删除成功",
                  });
                  var currentNode = _this.zTeeObj.getNodeByParam(
                    "dept01",
                    _this.selectNode.dept01
                  );
                  _this.zTeeObj.removeNode(currentNode);
                } else {
                  _this.$message({
                    type: "waring",
                    message: "删除失败",
                  });
                }
              });
            });
          } else {
            _this.zTeeObj.editName(_this.selectNode);
          }
        });

      function beforeRename(treeId, treeNode, newName, isCancel) {
        if (newName != treeNode.name) {
          let params = {
            dept01: treeNode.dept01,
            dept02: newName,
            dept03: treeNode.dept03,
            dept04: treeNode.dept04,
            dept05: treeNode.dept05 || 0,
          };
          EditCompanyDept({ model: JSON.stringify(params) }).then((res) => {
            _this.$message({
              type: "success",
              message: "更新成功",
            });
          });
        }
      }
    },
    addDialogFormVisible1Open() {
      this.addDialogFormVisible1 = true;
      setTimeout(() => {
        this.first();
      }, 100);
    },
    first() {
      var that = this;
      // 模拟城市-无联动/无搜索
      var selector1 = $("#city-picker-selector1").cityPicker({
        dataJson: cityData,
        renderMode: true,
        search: true,
        storage: true,
        autoSelected: true,
        shorthand: false,
        code: "cityCode",
        level: 2,
        onChoiceEnd: function () {
          that.addList.user10 = selector1.getCityNameVal();
        },
      });
      if (that.addList.user10 != null) {
        selector1.setCityVal(that.addList.user10.split("/")[0]);
        this.detialAdree = that.addList.user10.split("/")[1];
      }
    },
    delCompanyUser(row) {
      //(row);
      this.$confirm("此操作会将此人移除该公司, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let params = {
            qid: localStorage.pid,
            uid: row.id,
          };
          delCompanyUser(params).then((res) => {
            if (res.Code > 0) {
              this.$message({
                type: "success",
                message: "移除成功",
              });
              this.getData();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 强制下线功能
    QuitUser(row) {
      this.$confirm("此操作将强制下线用户, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let params = {
            uid: row.id,
          };
          QuitUser({ ...params }).then((res) => {
            if (res.Code > 0) {
              this.$message({
                type: "success",
                message: "已强制下线！",
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    invDialogFormVisible2() {
      this.invDialogFormVisible1 = true;
      let params = {
        pid: localStorage.getItem("pid"),
      };
      GetProjectDept({ params }).then((res) => {
        this.removeNull(res.Data);
        this.qyList = res.Data;
      });
    },
    // 邀请用户
    invite() {
      this.inviteList.forEach((v) => {
        v.Account = v.Phone = v.Email;
      });
      let params = JSON.stringify(this.inviteList);
      //(params);
      InviteCorporateGovernanceUser({ model: params }).then((res) => {
        if (res.Code > 0) {
          this.$message({
            type: "success",
            message: res.Message,
          });
        } else {
          this.$message({
            type: "warning",
            message: res.Message,
          });
        }
      });
      this.invDialogFormVisible1 = false;
    },
    // 邀请用户列表增加
    addInviteList(index) {
      //(index);
      this.inviteList.splice(index + 1, 0, {
        CompanyId: localStorage.getItem("pid"),
      });
    },
    delInviteList(index) {
      this.inviteList.splice(index, 1);
    },
    // 导出表格所用
    exportExcel() {
      var _this = this;
      const promise = new Promise(function (resolve, reject) {
        _this.zhiwei = false;
        resolve();
      });
      promise.then(() => {
        let time = new Date();
        let year = time.getFullYear();
        let month = time.getMonth() + 1;
        let day = time.getDate();
        let name = year + "" + month + "" + day;
        //  .table要导出的是哪一个表格
        var wb = XLSX.utils.table_to_book(document.querySelector(".table"));
        var wbout = XLSX.write(wb, {
          bookType: "xlsx",
          bookSST: true,
          type: "array",
        });
        try {
          FileSaver.saveAs(
            new Blob([wbout], { type: "application/octet-stream" }),
            name + ".xlsx"
          );
        } catch (e) {}
        return wbout;
      });
    },
    //
    addcount() {
      GetDeptList().then((res) => {
        this.deptList = res.data;
      });
    },
    // 批量删除
    batchDeletion() {
      if (this.multipleSelection.length > 0) {
        this.$confirm("此操作移除所选择用户, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          var Selection = [];
          this.multipleSelection.forEach((item, index) => {
            Selection.push(item.user01);
          });
          //(row);
          let uid = localStorage.getItem("pid");
          RemoveCorporateGovernanceUser({ ids: Selection }).then((res) => {
            if (res.state == 1) {
              this.$message({
                message: "移除成功",
                type: "success",
              });
              this.getData();
            } else {
              this.$message({
                message: "移除失败",
                type: "warning",
              });
            }
          });
        });
      } else {
        this.$message({
          message: "没有选择",
          type: "warning",
        });
      }
    },
    // 新增人员
    editUserSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var address = this.addList.user10;
          this.addList.user10 = this.addList.user10 + "/" + this.detialAdree;
          this.deptIds = this.addList.deptIds[this.addList.deptIds.length - 1];
          AddCompanyUser({
            pid: localStorage.getItem("pid"),
            user: JSON.stringify(this.addList),
            position: this.addList.positions,
            deptId: this.deptIds,
          }).then((res) => {
            if (res.Code === 1) {
              this.$message({
                message: "添加人员成功",
                type: "success",
              });
              this.getData();
              this.addDialogFormVisible1 = false;
            } else {
              this.addForm.user10 = address;
              this.$message({
                type: "warning",
                message: res.Message,
              });
            }
          });
        }
      });
    },
    // 删除用户
    showDeleteDialog(row) {
      //(row);
      let qid = localStorage.getItem("pid");
      let uid = row.id;
      this.$confirm("此操作将该用户移除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        RemoveCorporateGovernanceUser({ qid, uid }).then((res) => {
          if (res.Code == 1) {
            this.$message({
              message: "移除成功",
              type: "success",
            });
            this.getData();
          } else {
            this.$message({
              message: "移除失败",
              type: "warning",
            });
          }
        });
      });
    },
    // 这里获取所有数据
    getData() {
      let params = {
        bids: this.ids,
        seachword: this.query,
        pid: localStorage.getItem("pid"),
        pageIndex: this.pagenum,
        pageSize: this.pagesize,
      };
      // GetCompanUserList
      AddCorporateGovernanceRen({ params }).then((res) => {
        this.userList = res.Data.list;
        this.total = res.Data.total;
        let params = {
          pid: localStorage.getItem("pid"),
        };
        GetProjectDept({ params }).then((res) => {
          // 这里修改下deptID的格式改为数组
          // 111
          this.removeNull(res.Data);
          this.qyList = res.Data;
        });
      });
    },
    removeNull(arr) {
      arr.forEach((ele) => {
        if (ele.children.length == 0) {
          delete ele.children;
        } else {
          this.removeNull(ele.children);
        }
      });
    },
    GetCorporateGovernanceDepartment() {
      let params = {
        qid: localStorage.getItem("pid"),
      };
      GetCorporateGovernanceDepartment({ params }).then((res) => {
        this.qyList = res.Data;
        this.zNodes = res.Data;
        this.init();
        this.userList.map((i, index) => {
          this.qyList.map((k, m) => {
            if (parseInt(i.CompanyDept) === k.dept01) {
              i.CompanyDept = k.dept02;
            }
          });
        });
      });
    },
    //显示编辑用户对话框
    seeDialogFormVisible(row) {
      this.seeDialogFormVisible1 = true;
      this.id = row.id;
      let params = {
        id: this.id,
      };
      GetUserInfo({ params }).then((res) => {
        this.addForm = res.Data;
        this.GetProjectList();
      });
    },
    // 获取用户的项目
    GetProjectList() {
      let params = {
        pid: localStorage.getItem("pid"),
        uid: this.id,
        pageIndex: this.pageIndex2,
        pageSize: this.pageSize2,
      };
      GetProjectList({ params }).then((res) => {
        this.userList2 = res.Data.list;
        this.total2 = res.Data.total;
        this.obligation = res.Data;
      });
    },
    // 是否禁用
    stopDialogFormVisible(row) {
      this.stateRow = row;
      if (row.State == 1) {
        this.changeEndTime = true;
      } else {
        this.stopUser();
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      this.pagenum = val;
      this.getData();
    },
    handleSizeChange2(val) {
      this.pageSize2 = val;
      this.GetProjectList();
    },
    handleCurrentChange2(val) {
      this.pageIndex2 = val;
      this.GetProjectList();
    },
    setCurrent(row) {
      this.$refs.singleTable.setCurrentRow(row);
    },
    handleCurrentChange2(val) {
      this.currentRow = val;
    },
    replaceSub() {
      this.seeDialogFormVisible2 = true;
    },
    // 关闭菜单栏显示
    adminshow() {
      this.$emit("update:showAdmin", true);
    },
    // 部门选择事件
    xz(data) {
      let params = {
        uid: data[1].id,
        qid: localStorage.getItem("pid"),
        bid: data[0][data[0].length - 1],
      };
      // 111
      UpdateCorporateGovernanceDepartment(params).then((res) => {
        if (res.Code === 1) {
          this.$message({
            type: "success",
            message: "修改部门成功",
          });
          this.getData();
        }
      });
    },
    // 职位输入框事件
    inputText(data, name) {
      //console.log(data);
      let params = {
        uid: data.id,
        qid: localStorage.getItem("pid"),
        Job: name,
      };
      UpdateCorporateGovernancePosition(params).then((res) => {
        if (res.Code === 1) {
          this.$message({
            type: "success",
            message: "修改成功",
          });
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
div#buildRmenu {
  position: fixed;
  visibility: hidden;
  top: 0;
  width: 60px;
  background-color: #35a5db;
  padding: 4px;
  border-radius: 3px;
  overflow: auto;
  border: 1px solid #eee;
}

div#buildRmenu ul {
  margin: 0px;
  padding: 0px;
}

div#buildRmenu ul li {
  font-size: 12px;
  line-height: 20px;
  margin: 0px;
  padding: 0px;
  cursor: pointer;
  list-style: none outside none; //取消样式
  background-color: rgba(255, 255, 255, 0);
  padding-left: 3px;
  margin: 1px auto;
  color: white;
  border-radius: 3px;
  letter-spacing: 1px;
}

div#buildRmenu ul li:hover {
  background: #eee;
  color: #000000;
}
#buildTree {
  height: 500px;
}
.zTreeDiv {
  overflow: auto;
}
.ztree li span {
  color: #fff;
  line-height: 21px;
  margin-right: 2px;
}
.user .margin-20 {
  margin: 20px 0;
}
.user .search-input {
  width: 300px;
}
.user .page {
  padding: 5px 0;
  background-color: #d3dce6;
}
.user {
  .btnArr {
    margin-top: 10px;
  }
}

.yq-col:nth-child(1) {
  overflow: hidden;
  span {
    position: relative;
    top: 5px;
    bottom: 10px;
    left: 10px;
  }
}
.yq-col:nth-child(2) {
  overflow: hidden;
  margin: 0 0 0 0px;
  span {
    position: relative;
    top: 5px;
    bottom: 10px;
    left: 10px;
  }
}
.yq-col:nth-child(3) {
  overflow: hidden;
  margin: 0 0 0 0px;
  span {
    position: relative;
    top: 5px;
    bottom: 10px;
    left: 10px;
  }
}
.yq-col:nth-child(4) {
  overflow: hidden;
  margin: 0 0 0 0px;
  span {
    position: relative;
    top: 5px;
    bottom: 10px;
    left: 10px;
  }
}
.user-loading {
  display: flex;
  margin: 10px 0;
  p {
    margin: 8px 0 0 10px;
    span {
      color: #007acc;
    }
  }
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.dome-main {
  padding: 0px;
}
.container {
  margin: 0px;
}
/deep/ #inputs .el-input__inner::-webkit-input-placeholder {
  color: #000000;
}
// 新增
.font-sz24 {
  font-size: 24px;
}
.head-text {
  float: right;
  margin-top: -4px;
}
.mar-r80 {
  margin-right: 80px;
}
.mar-top20 {
  margin-top: 20px;
}
.elAside {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  text-align: center;
}
.width100 {
  width: 100%;
}
.mar-left10 {
  margin-left: 10px;
}
.width80 {
  width: 80%;
}
.padding0 {
  padding: 0;
}
</style>
